<template>
    <component :is="isMobile ? 'q-slide-item' : 'div'" :class="{
            'is-expanded' : isExpanded,
            'is-unread' : !notification.read || currentTab=='history',
            '-no-reply': currentTab=='history' || currentTab=='errors' || notification.created_by.id == myUserProfile.id
        }" @click="toggleExpanded()" ref="js-slider"
        v-if="notification && !deletedNotifications[currentTab].includes(notification.id)" left-color="red"
        @left="onLeft" @slide="sliding($event)" :data-component-name="$options.name">
        <template v-slot:left v-if="isMobile">
            <div class="slider-icon">
                <div class="column items-center">
                    <q-icon name="delete" class="q-mb-sm" size="16px" />
                    <div>Supprimer</div>
                </div>
            </div>
        </template>

        <div class="c-notifications-checkbox" v-if="(currentTab=='inbox' || currentTab=='sent') && !inPage">
            <q-checkbox dense size="24px" color="blue" :value="selected.includes(notification.id)"
                @input="$emit('set-selected')" />
        </div>

        <div class="c-notifications-avatar" v-if="!inPage">
            <UserAvatar :name="notification.created_by.name" :email="notification.created_by.email"
                v-if="currentTab=='inbox'" />
            <UserAvatar :name="notification.recipients[0].name" :recipients="notification.recipients"
                :email="notification.recipients[0].email" v-if="currentTab=='sent'" />
            <UserAvatar :name="null" :email="null" color="red" icon="priority_high"
                v-if="currentTab=='errors' && notification.type=='ASSIGNMENTCONFLICT'" />
            <UserAvatar :name="null" :email="null" color="red" icon="event_busy"
                v-if="currentTab=='errors' && notification.type=='ABSENCECONFLICT'" />
        </div>

        <div class="c-notifications-content" v-if="!inPage">
            <div class="-from">
                <span class="-from-name" v-if="currentTab=='history'">
                    {{ notification.created_by.name }}
                </span>
                <span class="-from-name" v-if="currentTab=='sent'">
                    <span class="" v-if="notification.recipients">
                        {{ recipients }}
                        <q-tooltip anchor="top middle" self="bottom middle">
                            <div style="max-width: 300px;">
                                {{ recipients }}
                            </div>
                        </q-tooltip>
                    </span>
                    <span v-else>
                        {{ notification.to.name }}
                    </span>
                </span>
                <span class="-from-name" v-else>
                    {{ notification.created_by.name }}
                </span>
                <span class="-from-date" v-html="getRelativeDate(notification.updated_at)">
                </span>
            </div>
            <div class="-subject">{{ notification.subject }}</div>
            <!-- <div class="-subject">{{ notification.subject }} {{ '- '+notification.id }} </div> -->
            <div class="-body" @click="bodyClicked($event, notification)" ref="body" v-if="isExpanded">
                <div class="-info" v-if="notification.info!='' && currentTab!='history'" v-html="notification.info">
                </div>
                <div class="-info" v-if="notification.message && notification.message!='' && currentTab=='history'"
                    v-html="notification.message"></div>
                <div v-if="notification.relationsData!=''" v-html="notification.relationsData"></div>

                <div class="-conversations" :class="'js-conversation'+notification.id"
                    @scroll.passive="conversationsScroll($event)">
                    <div class="-conversations-group" :key="cgi"
                        v-for="(conversations, cgi) in notification.conversationsGroups">
                        <div class="-date-time" v-html="conversations.created_at" v-if="conversations.created_at">
                        </div>
                        <div class="-signature" :class="{ '-from-me': conversations.created_by.id == myUserProfileID}"
                            v-if="conversations.created_by">
                            <!-- <UserAvatar 
                                :name="conversations.created_by.name"
                                :email="conversations.created_by.email"
                                size="xs"
                                class="q-mr-xs"
                            /> -->
                            <span class="q-mr-xs">
                                {{ conversations.created_by.name }}
                            </span>
                        </div>

                        <div class="-conversation" :key="ci" v-for="(conversation, ci) in conversations.items"
                            :class="{ '-from-me': conversation.created_by.id == myUserProfileID}">
                            <!-- <div class="-date-time"
                                v-if="ci==0 && conversations.created_at && conversation.created_by.id == myUserProfileID"
                                v-html="getRelativeDate(conversations.created_at)+ ' - '+conversations.diff"
                            > -->
                            <!-- </div> -->
                            <div class="-message" v-if="conversation.message" v-html="conversation.message">
                            </div>
                            <!-- <div class="-date-time"
                                v-if="ci==0 && conversations.created_at && conversation.created_by.id != myUserProfileID"
                                v-html="getRelativeDate(conversations.created_at)+ ' - '+conversations.diff"
                            > -->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>

                <div class="-reply__wrap"
                    v-if="currentTab!='history' && currentTab!='errors' && ((currentTab=='inbox' && notification.created_by.id != myUserProfile.id) || (currentTab=='sent' && notification.to.id!=myUserProfile.id))">
                    <UserAvatar :name="myUserProfile.name" :email="myUserProfile.email" class="q-mt-sm" />

                    <Input ref="replyInput" v-model="replyInput" class="-reply-input q-ml-sm" :filled="false"
                        :borderless="true" dense autogrow :withEmoji="true" placeholder="Répondre" :submitOnEnter="true"
                        @afterIcon-click="sendReply(replyInput, notification.id)"
                        @enter-submit="sendReply(replyInput, notification.id)" />
                </div>
            </div>
        </div>

        <div class="c-notifications-content" v-if="inPage" ref="js-content">
            <div class="c-notifications-checkbox -hidden-mobile" v-if="(currentTab=='inbox' || currentTab=='sent')">
                <q-checkbox dense size="24px" color="blue" :value="selected.includes(notification.id)"
                    @input="$emit('set-selected')" />
            </div>

            <div class="c-notifications-avatar">
                <UserAvatar :name="notification.created_by.name" :email="notification.created_by.email"
                    v-if="currentTab=='inbox'" />
                <UserAvatar :name="notification.recipients[0].name" :recipients="notification.recipients"
                    :email="notification.recipients[0].email" v-if="currentTab=='sent'" />
                <UserAvatar :name="null" :email="null" color="red" icon="priority_high"
                    v-if="currentTab=='errors' && notification.type=='ASSIGNMENTCONFLICT'" />
                <UserAvatar :name="null" :email="null" color="red" icon="event_busy"
                    v-if="currentTab=='errors' && notification.type=='ABSENCECONFLICT'" />
            </div>
            <div class="-from">
                <span class="-from-name u-maxw-100 u-text-truncate" v-if="currentTab=='history'">
                    {{ notification.created_by.name }}
                </span>
                <span class="-from-name u-maxw-100" v-if="currentTab=='sent'">
                    <div class="o-row u-maxw-100">
                        <span class="u-text-truncate" v-if="notification.recipients">
                            {{ recipients }}
                            <q-tooltip anchor="top middle" self="bottom middle">
                                <div style="max-width: 300px;">
                                    {{ recipients }}
                                </div>
                            </q-tooltip>
                        </span>
                        <span v-else>
                            {{ notification.to.name }}
                        </span>
                        <div class="-date -hidden-desktop text-no-wrap"
                            v-html="getRelativeDate(notification.updated_at)"></div>
                    </div>
                    <div class="-subject -hidden-desktop">{{ notification.subject }}</div>
                    <div class="-info -hidden-desktop" v-if="notification.info!='' && currentTab!='history'"
                        v-html="notification.info"></div>
                </span>
                <span class="-from-name u-maxw-100" v-else>
                    <div class="o-row u-maxw-100 u-text-truncate">
                        {{ notification.created_by.name }}
                        <div class="-date -hidden-desktop text-no-wrap"
                            v-html="getRelativeDate(notification.updated_at)"></div>
                    </div>
                    <div class="-subject -hidden-desktop">{{ notification.subject }}</div>
                    <div class="-info -hidden-desktop" v-if="notification.info!='' && currentTab!='history'"
                        v-html="notification.info"></div>
                </span>
                <span class="-from-date" v-html="getRelativeDate(notification.updated_at)">
                </span>
            </div>
            <div class="-subject -hidden-mobile">{{ notification.subject }}</div>
            <div class="-date -hidden-mobile" v-html="getRelativeDate(notification.updated_at)"></div>
            <div class="c-notifications-controls -hidden-mobile" v-if="currentTab=='inbox' || currentTab=='sent'">
                <span>
                    <q-spinner color="primary" v-if="deletedNotifications[currentTab].includes(notification.id)" />
                    <q-icon name="delete" @click.stop="$emit('delete-notification')" v-else />
                </span>
                <!-- <span>
                    <q-icon name="reply"
                        @click.stop="replyTo(notification)"                    
                    />
                </span> -->
            </div>
        </div>

        <div class="c-notifications-controls" v-if="(currentTab=='inbox' || currentTab=='sent') && !inPage">
            <span>
                <q-spinner color="primary" v-if="deletedNotifications[currentTab].includes(notification.id)" />
                <q-icon name="delete" @click.stop="$emit('delete-notification')" v-else />
            </span>
            <!-- <span>
                <q-icon name="reply"
                    @click.stop="replyTo(notification)"                    
                />
            </span> -->
        </div>
        <div class="c-notifications-controls" v-else-if="!inPage">
            <q-spinner color="primary" style="visibility: hidden;" />
        </div>

        <div class="c-notifications-content -body__wrapper full-width" v-if="inPage && isExpanded">
            <div class="c-notifications-checkbox">
            </div>
            <div class="c-notifications-avatar">
            </div>
            <div class="-body" @click="bodyClicked($event, notification)" ref="body">
                <div class="-info" v-if="notification.info!='' && currentTab!='history'" v-html="notification.info">
                </div>
                <div class="-info" v-if="notification.message!='' && currentTab=='history'"
                    v-html="notification.message"></div>
                <div v-if="notification.relationsData!=''" v-html="notification.relationsData"></div>

                <div class="-conversations" :class="'js-conversation'+notification.id"
                    @scroll.passive="conversationsScroll($event)">
                    <div class="-conversations-group" :key="cgi"
                        v-for="(conversations, cgi) in notification.conversationsGroups">
                        <div class="-date-time" v-html="conversations.created_at" v-if="conversations.created_at">
                        </div>
                        <div class="-signature" :class="{ '-from-me': conversations.created_by.id == myUserProfileID}"
                            v-if="conversations.created_by">
                            <!-- <UserAvatar 
                                :name="conversations.created_by.name"
                                :email="conversations.created_by.email"
                                size="xs"
                                class="q-mr-xs"
                            /> -->
                            <span class="q-mr-xs">
                                {{ conversations.created_by.name }}
                            </span>
                        </div>

                        <div class="-conversation" :key="ci" v-for="(conversation, ci) in conversations.items"
                            :class="{ '-from-me': conversation.created_by.id == myUserProfileID}">
                            <!-- <div class="-date-time"
                                v-if="ci==0 && conversations.created_at && conversation.created_by.id == myUserProfileID"
                                v-html="getRelativeDate(conversations.created_at)+ ' - '+conversations.diff"
                            > -->
                            <!-- </div> -->
                            <div class="-message" v-if="conversation.message" v-html="conversation.message">
                            </div>
                            <!-- <div class="-date-time"
                                v-if="ci==0 && conversations.created_at && conversation.created_by.id != myUserProfileID"
                                v-html="getRelativeDate(conversations.created_at)+ ' - '+conversations.diff"
                            > -->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>

                <div class="-reply__wrap"
                    v-if="currentTab!='history' && currentTab!='errors' && (currentTab=='inbox' || currentTab=='sent')">
                    <UserAvatar :name="myUserProfile.name" :email="myUserProfile.email" class="q-mt-sm" />

                    <Input ref="replyInput" v-model="replyInput" class="-reply-input q-ml-sm -hidden-mobile"
                        :filled="false" :borderless="true" dense autogrow :withEmoji="true" placeholder="Répondre"
                        :submitOnEnter="true" @afterIcon-click="sendReply(replyInput, notification.id)"
                        @enter-submit="sendReply(replyInput, notification.id)" />
                    <Input ref="replyInput" v-model="replyInput" class="-reply-input q-ml-sm -hidden-desktop"
                        :filled="false" :borderless="true" dense autogrow :withEmoji="false" placeholder="Répondre"
                        :submitOnEnter="true" afterIcon="send" @afterIcon-click="sendReply(replyInput, notification.id)"
                        @enter-submit="sendReply(replyInput, notification.id)" />
                </div>
            </div>
        </div>



    </component>
</template>

<script>
    // import { HISTORY } from "@/graphql/history/queries";
    import { INBOXDETAILS/*, NOTIFICATIONSCOUNT/*, PROJECTSINBOX*/ } from "@/graphql/notification/queries";
    import { MARKASREAD, REPLYNOTIFICATION/*, SENDMESSAGE*/ } from "@/graphql/notification/mutations"
    // // import { MYPROFILE } from '@/graphql/user/queries'
    import { isJson } from "@/js/utilities";
    import { relativeDate, dayOfWeekStr, dayStr, monthStr } from "@/js/dateUtilities";
    // import uniqBy from 'lodash/uniqBy'
    import moment from 'moment';

    export default {
        name: 'Notification',
        props: {
            parentNotification: {
                type: Object,
                default: null
            },
            currentTab: {
                type: String,
                default: null
            },
            selected: {
                type: Array,
                default(){
                    return [];
                }
            },
            deletedNotifications: {
                type: Object,
                default(){
                    return {};
                }
            },
            inPage: {
                type: Boolean,
                default: false
            },
            projectID: {
                type: [Number, String],
                default: null
            },
            isMobile: {
                type: Boolean,
                default: false
            }
            // parentProject: {
            //     type: Object,
            //     default: null
            // },
            // userProfileIDprop: {
            //     type: Number,
            //     default: null
            // },
            // globalPanel: {
            //     type: Boolean,
            //     default: false
            // },
        },
        data(){
            return {
                appName: process.env.VUE_APP_NAME,
                myUserProfileID: window.myUserProfileID,
                myUserProfile: window.myUserProfile,
                isExpanded: false,
                replyInput: '',
                lastConversationScroll: 0,
                listenScroll: true,
                listenScrollTO: {},
                watchNotificationTO: {},
                notification:null,
                smarted: false
            }
        },
        mounted(){
            // alert('icic')
            if (!this.notification) this.notification = JSON.parse(JSON.stringify(this.parentNotification))
        },
        beforeDestroy() {
        },
        computed: {
            recipients(){
                if(!this.notification.recipients) return [];
                return this.notification.recipients.map(a => a.name).join(', ');
            }
        },
        methods: {
            getRelativeDate(date){
                return relativeDate(date);
            },
            conversationsScroll(e){
                if( e.target.scrollTop>this.lastConversationScroll && e.target.scrollTop-this.lastConversationScroll>5 ){
                    this.lastConversationScroll=e.target.scrollTop;
                    let dataEls=this.$refs.body.querySelectorAll(".c-notifications-data");
                    if(dataEls && this.listenScroll){
                        this.listenScroll=false;

                        dataEls.forEach(function(el){
                            el.classList.add("-collapsed");
                        })

                        clearTimeout(this.listenScrollTO);
                        this.listenScrollTO = setTimeout(function(){
                            this.listenScroll=true;
                        }.bind(this), 300)
                    }
                }else if(e.target.scrollTop<this.lastConversationScroll && this.lastConversationScroll-e.target.scrollTop ){
                    if(e.target.scrollTop==0 && this.listenScroll){
                        let dataEls=this.$refs.body.querySelectorAll(".c-notifications-data");
                        if(dataEls && this.listenScroll){
                            this.listenScroll=false;
                            
                            dataEls.forEach(function(el){
                                el.classList.remove("-collapsed");
                            })

                            clearTimeout(this.listenScrollTO);
                            this.listenScrollTO = setTimeout(function(){
                                this.listenScroll=true;
                            }.bind(this), 300)
                        }
                    }
                    this.lastConversationScroll=e.target.scrollTop;
                }
            },
            bodyClicked(e){
                e.stopPropagation();
// console.log(e)
                // let emoji=false;
                if (e.path) {
                    e.path.forEach(element => {
                        if (element.id == "emoji-container" && e.target.id != "emoji-popup" && !e.target.classList.contains("js-emojipicker")) {
                            // emoji=true;
                            if (this.$refs.replyInput?.$refs.EmojiPicker?.$refs.picker?.isPickerOpen) {
                                this.$refs.replyInput.$refs.EmojiPicker.$refs.picker.isPickerOpen = false;
                                return;
                            }

                        }
                        if (element.classList && element.classList.contains("c-notifications-data") && element.classList.contains("-collapsed")) {
                            e.stopPropagation();
                            this.listenScroll = false;
                            element.classList.remove("-collapsed")
                            let conversationEl = this.$el.querySelectorAll(".js-conversation" + this.notification.id)
                            if (conversationEl) {
                                conversationEl.forEach(function (el) {
                                    el.scrollTop = 121000;
                                })
                            }

                            clearTimeout(this.listenScrollTO);
                            this.listenScrollTO = setTimeout(function () {
                                this.listenScroll = true;
                            }.bind(this), 300)

                            return;
                        }
                    });
                }
                // if(!emoji && e.target.id!="emoji-popup" && !e.target.classList.contains("js-emojipicker")){
                //     if(this.$refs.replyInput?.$refs.EmojiPicker?.$refs.picker?.isPickerOpen){
                //         this.$refs.replyInput.$refs.EmojiPicker.$refs.picker.isPickerOpen=false;
                //         return;
                //     }
                // }
                
                if(e.target.classList.contains("o-button")){
                    e.stopPropagation();
                    this.$eventBus.$emit('jump-to-project', { projectID: e.target.dataset.projectid, currentDate: e.target.dataset.date})
                    return;
                }
                if(e.target.classList.contains("c-notifications-data") && e.target.classList.contains("-collapsed")){
                    e.stopPropagation();
                    this.listenScroll=false;
                    e.target.classList.remove("-collapsed")
                    let conversationEl=this.$el.querySelectorAll(".js-conversation"+this.notification.id)
                    if(conversationEl){
                        conversationEl.forEach(function(el){
                            el.scrollTop=121000;
                        })
                    }    

                    clearTimeout(this.listenScrollTO);
                    this.listenScrollTO = setTimeout(function(){
                        this.listenScroll=true;
                    }.bind(this), 300)
                }
            },
            toggleExpanded() {
                if (this.currentTab == "history") return;
                if(this.isExpanded){
                    this.isExpanded=false;
                    this.$emit('notification-scroll')
                }else{                  
                    this.isExpanded=true
                    this.isLoadingMore=true;

                    if(!this.smarted){
                        this.$apollo.addSmartQuery('inbox', {
                            query: INBOXDETAILS,
                            fetchPolicy: 'network-only',
                            variables: {
                                id: this.notification.id,
                                subscribe: true
                            },
                            update(data){
                                if (data.inbox.data.length) this.notification=data.inbox.data[0]
                            }
                        })
                    }
                    this.smarted=true;

                    this.$eventBus.$emit('subscribe-to-conversation', {
                        notificationID: this.notification.id,
                        expires: 60000
                    });

                    setTimeout(function(){
                        let conversationEl=document.querySelectorAll(".js-conversation"+this.notification.id)
                        if(conversationEl){
                            this.listenScroll=true;
                            conversationEl.forEach(function(el){
                                el.scrollTop=10000000;
                            })
                        }
                    }.bind(this), 200)
                    

                    if(!this.notification.read) {
                        this.$apollo.mutate({
                            mutation: MARKASREAD,
                            variables: {
                                id: this.notification.id
                            },
                        }).then(function(){
                            this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
                            this.notification.read=true;
                            // this.watcher=Date.now();
                        }.bind(this))
                    }

                    if(this.inPage){
                        let scrollArea=this.$parent.$refs["js-notifications-list"]
                        if(scrollArea){
                            // scrollArea.classList.remove('-snap-enable')
                            this.$scrollTo(this.$refs['js-content'], 500, {
                                container: scrollArea,
                                onDone: function(){
                                    this.$nextTick(function(){
                                        // scrollArea.classList.add('-snap-enable')
                                    })
                                }.bind(this)
                            })
                        }
                    }

                }
            },
            sendReply(message, notificationID){
                if(!message || message.trim()=='') return;

                this.$apollo.mutate({
                    mutation: REPLYNOTIFICATION,
                    variables: {
                        isReply: true,
                        notificationID: notificationID,
                        message: message
                    }
                }).then(function(data){
                    if(data?.data?.replyNotification[0]?.conversations) {
                        this.notification=data.data.replyNotification[0];
                    }

                    this.$eventBus.$emit('subscribe-to-conversation', {
                        notificationID: this.notification.id,
                        expires: 180000
                    });
                    this.replyInput='';
                }.bind(this))
            },
            sliding(e){
                if(e.side=='left'){
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__left").style.opacity=e.ratio
                    let translateX=e.ratio*80;
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__content").style.transform='translateX('+translateX+'px)';
                }
                if(e.side=='right'){
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__right").style.opacity=e.ratio
                    let translateX=e.ratio*80;
                    this.$refs['js-slider'].$el.querySelector(".q-slide-item__content").style.transform='translateX(-'+translateX+'px)';
                }
            },
            onLeft({ reset }){
                this.reset=reset;
                this.$emit('delete-notification')
                return;
                // this.finalize(reset)
            },
            finalize (reset) {
                this.timer = setTimeout(() => {
                    reset()
                }, 100)
            },

            parseNotification(){
                let notification = this.notification;
                if (!notification) return
                let tempMSG='';
                if( notification.message && isJson(notification.message) ) tempMSG=JSON.parse(notification.message);
                if( Array.isArray(tempMSG) ) notification.message="<div>" + tempMSG.join("</div><div>") + "</div>";
                if(this.currentTab=='sent') notification.read=true;
                if(notification.conversations){
                    notification.conversationsGroups = [];
                    let lastCreator=null;
                    let lastDateTime=null

                    notification.conversations.forEach( function(reply, index){
                        if(!reply.message || reply.message==''){
                            delete notification.conversations[index]
                        }else{
                                                                
                            if(!lastCreator || reply.created_by.id!=lastCreator.id){
                                if (
                                    !lastDateTime 
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<30 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'minutes', true))>=5)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<60 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=15)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))<24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=1)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'days', true))>=1)
                                ){
                                    let dateStr=this.getRelativeDate(reply.created_at);
                                    if(Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=48) {
                                        let date=new Date(moment(reply.created_at));
                                        dateStr=dayOfWeekStr(date).full + ' ' + dayStr(date.getDate()) + ' ' + monthStr(date).full.toLowerCase() + ' ' + date.getFullYear();
                                    }

                                    notification.conversationsGroups.push({
                                        created_at: dateStr,
                                        // diff: Math.round(moment().diff(moment(reply.created_at), 'hours', true)),
                                        created_by: reply.created_by,
                                        items: [reply]
                                    });
                                    lastDateTime=reply.created_at;
                                }else{
                                    notification.conversationsGroups.push({
                                        created_by: reply.created_by,
                                        items: [reply]
                                    });
                                }
                                
                                lastCreator=reply.created_by;

                            }else if (
                                !lastDateTime 
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<30 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'minutes', true))>=5)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<60 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=15)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))<24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=1)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'days', true))>=1)
                            ){
                                lastDateTime=reply.created_at;

                                let dateStr=this.getRelativeDate(reply.created_at);
                                if(Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=48) {
                                    let date=new Date(moment(reply.created_at));
                                    dateStr=dayOfWeekStr(date).full + ' ' + dayStr(date.getDate()) + ' ' + monthStr(date).full.toLowerCase() + ' ' + date.getFullYear();
                                }


                                notification.conversationsGroups.push({
                                    created_at: dateStr,
                                    created_by: reply.created_by,
                                    // diff: Math.round(moment().diff(moment(reply.created_at), 'hours', true)),
                                    items: [reply]
                                });
                            }else{
                                notification.conversationsGroups[notification.conversationsGroups.length-1].items.push(reply)
                            }

                        }
                        
                    }.bind(this))
                    notification.conversations=Object.values(notification.conversations)
                }
                if (this.currentTab == "errors") {
                    if (!notification.created_by) notification.created_by = {};
                    notification.created_by.name=this.appName;
                }

                this.notification=notification

                setTimeout(function(){
                    this.$nextTick(function(){
                        let conversationEl=this.$el.querySelectorAll(".js-conversation"+this.notification.id)
                        if(conversationEl){
                            this.listenScroll=true;
                            conversationEl.forEach(function(el){
                                el.scrollTop=121000;
                            })
                        }    
                    }.bind(this))

                }.bind(this), 100)
            }
        },
        watch: {
            notification: function(){
                if(this.smarted) this.parseNotification();
                clearTimeout(this.watchNotificationTO);
                this.watchNotificationTO = setTimeout(function(){
                    this.$nextTick(function(){
                        if(!this.$el) return;
                        let conversationEl=this.$el.querySelectorAll(".js-conversation"+this.notification.id)
                        if(conversationEl){
                            this.listenScroll=true;
                            conversationEl.forEach(function(el){
                                el.scrollTop=121000;
                            })
                        }
                    }.bind(this))
                    
                }.bind(this), 1000)
            }
        }
    }
</script>
<style lang="scss">
    @import "@/scss/components/notifications/Notifications2.scss";
</style>